import { render, staticRenderFns } from "./DegreeSave.vue?vue&type=template&id=25eb712a&scoped=true"
import script from "./DegreeSave.vue?vue&type=script&lang=js"
export * from "./DegreeSave.vue?vue&type=script&lang=js"
import style0 from "./DegreeSave.vue?vue&type=style&index=0&id=25eb712a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb712a",
  null
  
)

export default component.exports